import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexColumn from '@ui/atoms/FlexColumn';

import { IDetail } from '@folx-types/text';
import { SpacingTypes } from '@folx-types/theme';

export interface IDetailTextProps extends IDetail {
	className?: string;
	gap?: SpacingTypes;
}

const DetailText: FC<IDetailTextProps> = ({ className, description, gap = 'xs', title }) => {
	return (
		<FlexColumn gap={gap} className={className}>
			<BasicText variant="field">{title}</BasicText>
			<BasicText variant="smallText">{description}</BasicText>
		</FlexColumn>
	);
};

export default styled(DetailText)``;
